import React from 'react'
import gql from 'graphql-tag'
import {useQuery} from '@apollo/react-hooks'

import Loader from 'shared/components/Loader'

import OtherBookingsTable from './OtherBookingsTable'
import OtherBookingsUpsell from './OtherBookingsUpsell'

import './index.css'

interface Props {
  booking: any
  serviceProviderId: string
}

const estateQuery = gql`
  query EstateQuery($estateId: ID!, $serviceProviderId: ID!) {
    estate(id: $estateId) {
      id
      broker {
        id
        phone
      }
      bookedServiceProviders {
        id
        name
        email
      }
      bookings(type: Attendance) {
        edges {
          node {
            id
            state
            resourceName
            startsAt
            products {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
      availableProducts(serviceProviderId: $serviceProviderId) {
        edges {
          node {
            id
            name
            __typename
            ... on PhotoBasedProduct { minQuantity }
          }
        }
      }
    }
  }
`

function OtherBookings({ booking, serviceProviderId }: Props) {
  const estateId = booking.estate.id
  const {data, loading, error, refetch} = useQuery(estateQuery, {
    variables: {estateId, serviceProviderId},
  })
  if (loading || error) {
    return <Loader loading={loading} error={error} />
  }

  return (
    <div className="other-bookings">
      <OtherBookingsTable 
        currentBookingId={booking.id} 
        bookings={data.estate.bookings}
        bookedServiceProviders={data.estate.bookedServiceProviders} 
      />
      <div className="other-booking-upsell">
        <OtherBookingsUpsell
          estate={data.estate}
          refetch={refetch}
          customerSpecificPriceListUrl={booking.customerSpecificPriceListUrl}
        />
      </div>
    </div>
  )
}

export default OtherBookings
